import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { baseHeaders } from 'util/axios-request';
import { exportLeaveDays } from 'api/approval/config';
var baseURL = process.env.VUE_APP_BASE_API;
export default {
  data: function data() {
    return {
      loading: false,
      visible: false,
      multiple: true,
      fileFormat: ['.xls', '.xlsx'],
      uploadUrl: baseURL + 'web/leave/importLeaveDays',
      baseHeaders: baseHeaders(),
      fileSize: 5,
      uploadHeaders: {},
      successFileList: [],
      uploadStatus: false,
      uploadTotalCount: 0,
      // 总数
      uploadSuccessCount: 0,
      // 成功数
      uploadFailCount: 0,
      // 失败数
      feedbackFileUrl: '',
      form: {
        name: ''
      }
    };
  },
  methods: {
    init: function init() {
      this.resetDate();
      this.visible = true;
    },
    handleExport: function handleExport() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              exportLeaveDays().then(function (res) {
                _this.loading = false;
                if (res && res.code === 1) window.open(res.data.template_url);
              }).catch(function (e) {
                _this.loading = false;
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    beforeUploadHandle: function beforeUploadHandle(file) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$confirm(_this2.$t('holiday_rest_11'), _this2.$t('holiday_rest_12'), {
                confirmButtonText: _this2.$t('holiday_rest_10'),
                cancelButtonText: _this2.$t('66'),
                type: 'warning'
              });
            case 2:
              res = _context2.sent;
              if (res === 'confirm') _this2.loading = true;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 上传成功+
    successHandle: function successHandle(res, file) {
      if (this.$refs.upload.uploadFiles.length > 1) {
        this.$refs.upload.uploadFiles.splice(0, 1);
      }
      this.uploadTotalCount = 0; // 总数
      this.uploadSuccessCount = 0; // 成功数
      this.uploadFailCount = 0; // 失败数
      var response = res;
      var data = response.data;
      this.loading = false;
      if (response && response.code === 1) {
        this.uploadStatus = true;
        if (data.upload_result_state === 1) {
          // 全部成功
          this.uploadTotalCount = data.upload_total_count;
          this.uploadSuccessCount = data.upload_success_count;
          this.uploadFailCount = data.upload_fail_count;
          this.$message.success(this.$t('935'));
          this.feedbackFileUrl = '';
        } else if (data.upload_result_state === 5) {
          // 部分成功
          this.uploadTotalCount = data.upload_total_count;
          this.uploadSuccessCount = data.upload_success_count;
          this.uploadFailCount = data.upload_fail_count;
          this.feedbackFileUrl = data.feedback_file_url;
          this.$message.error(this.$t('936'));
        } else if (data.upload_result_state === 3) {
          // 全部失败
          this.uploadTotalCount = data.upload_total_count;
          this.uploadSuccessCount = data.upload_success_count;
          this.uploadFailCount = data.upload_fail_count;
          this.feedbackFileUrl = data.feedback_file_url;
          this.$message.error(this.$t('937'));
        }
      } else {
        this.$message.error(res.message);
      }
    },
    handleOpenUrl: function handleOpenUrl() {
      window.open(this.feedbackFileUrl);
    },
    // 上传失败
    // err, file, fileList
    errorHandle: function errorHandle(err, file) {
      this.loading = false;
      var index = this.$refs.upload.uploadFiles.findIndex(function (v) {
        return v.name === file.name;
      });
      this.$refs.upload.uploadFiles.splice(index, 1);
      this.$message.error(this.$t('upload_error'));
      throw err;
    },
    resetDate: function resetDate() {
      this.uploadTotalCount = 0; // 总数
      this.uploadSuccessCount = 0; // 成功数
      this.uploadFailCount = 0; // 失败数
      this.feedbackFileUrl = '';
      this.uploadStatus = false;
    },
    // 弹窗关闭时
    closeHandle: function closeHandle() {
      this.reset();
      this.resetDate();
    },
    reset: function reset() {
      this.$refs.upload && this.$refs.upload.clearFiles();
      this.successFileList = [];
    },
    doSubmit: function doSubmit() {
      this.visible = false;
      this.resetDate();
      this.$emit('submit');
    }
  },
  watch: {
    successFileList: {
      handler: function handler(val) {
        if (val.length) this.$emit('uploadSuccess', val);
      },
      deep: true
    }
  }
};